/**
 * Custom cursor for fine pointers: a plum dot with a trailing rose ring that grows and shows a
 * label ("View", "Call") over [data-cursor] elements. The native cursor is never hidden, and the
 * custom one steps aside over form fields so typing stays completely standard.
 */
import { gsap } from 'gsap';

export function initCursor() {
  const root = document.querySelector('[data-cursor-root]');
  if (!root || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.documentElement.classList.add('has-cursor');

  const dot = root.querySelector('.cursor__dot');
  const ring = root.querySelector('.cursor__ring');
  const label = root.querySelector('[data-cursor-label]');
  gsap.set([dot, ring], { x: -100, y: -100 });
  const dx = gsap.quickTo(dot, 'x', { duration: 0.12, ease: 'power3.out' });
  const dy = gsap.quickTo(dot, 'y', { duration: 0.12, ease: 'power3.out' });
  const rx = gsap.quickTo(ring, 'x', { duration: 0.5, ease: 'power3.out' });
  const ry = gsap.quickTo(ring, 'y', { duration: 0.5, ease: 'power3.out' });

  window.addEventListener('pointermove', (e) => {
    if (e.pointerType !== 'mouse') return;
    dx(e.clientX); dy(e.clientY); rx(e.clientX); ry(e.clientY);
  }, { passive: true });

  // Hidden while over a form field (so typing stays standard) or while the pointer is outside the page.
  let overField = false;
  let outside = false;
  const syncHidden = () => root.classList.toggle('is-hidden', overField || outside);

  document.addEventListener('pointerover', (e) => {
    const t = e.target;
    const labelled = t.closest('[data-cursor]');
    const field = t.closest('input, textarea, select, label.check, .field');
    const interactive = t.closest('a, button');
    overField = Boolean(field);
    syncHidden();
    root.classList.toggle('is-label', Boolean(labelled) && !field);
    root.classList.toggle('is-hover', Boolean(interactive) && !labelled && !field);
    if (labelled) label.textContent = labelled.dataset.cursor;
  });

  document.documentElement.addEventListener('pointerleave', () => { outside = true; syncHidden(); });
  document.documentElement.addEventListener('pointerenter', () => { outside = false; syncHidden(); });
}
